import React from "react";
import { GridQuantityContainer, GridQuantityLabel } from "./styles";

interface SpanProps {
  "data-cy": string;
}
interface LabelQuantityProps {
  title: string;
  value: number | string;
  titleProps?: SpanProps;
  valueProps?: SpanProps;
  small?: boolean;
}

export const GridQuantity = ({
  title,
  value,
  titleProps,
  valueProps,
  small,
}: LabelQuantityProps) => {
  return (
    <GridQuantityContainer small={small}>
      <GridQuantityLabel {...titleProps}>{title}</GridQuantityLabel>
      <GridQuantityLabel isValue {...valueProps}>
        {value}
      </GridQuantityLabel>
    </GridQuantityContainer>
  );
};
